import '../styling/global.css';
import wedooimage from '../assets/wedoo_logo.png';
import img1 from '../assets/img1.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';
import img4 from '../assets/img4.png';
import img5 from '../assets/img5.png';
import img6 from '../assets/img6.png';
import img7 from '../assets/img7.png';
import Background from '../components/Background';


const ProductWedoo = () => {
    return (
        <div className="wedoo-page">
            <Background/>
            <img src={wedooimage} alt="Wedoo logo" className="wedoo-img" />
            <p>At wedoo, we believe that everyone deserves a hassle-free home. That’s why we created a simple, reliable app that connects you with trusted professionals for all your household chores—whether it's plumbing, electrical work, housekeeping, or general repairs.<br />
                Our mission is to make home maintenance easy and stress-free. With just a few taps, you can book skilled service providers who are vetted, punctual, and committed to quality. No more searching, guessing, or waiting—wedoo does the hard work for you, so you can focus on what matters most.<br />
                <br/>
                We’re not just an app—we’re your everyday helping hand.</p>
            <div className="images-card">
                <div className="image-frame">
                    <div className="image-container">
                        <img src={img1} alt="Image1" />
                        <p>Wedoo app home screen</p>
                    </div>
                    <div className="image-container">
                        <img src={img2} alt="Image2" />
                        <p>Booking a wedooer</p>
                    </div>
                    <div className="image-container">
                        <img src={img3} alt="Image3" />
                        <p>Connecting wedooer in your radius</p>
                    </div>
                </div>
                <div className="image-frame">
                    <div className="image-container">
                        <img src={img4} alt="Image4" />
                        <p>Connected wedooer</p>
                    </div>
                    <div className="image-container">
                        <img src={img5} alt="Image5" />
                        <p> Payment to the wedooer before work</p>
                    </div>
                    <div className="image-container">
                        <img src={img6} alt="Image6" />
                        <p> OTP is shared to the wedooer to start the work</p>
                    </div>
                </div>
                <div className="image-frame left-align last-section">
                    <div className="image-container">
                        <img src={img7} alt="Image7" />
                        <p style={{ marginLeft: "8rem" }}>Wedooer shares back the OTP after completion of the work.</p>
                    </div>
                    <div className="text-container">
                        <h2>Visit our website at</h2>
                        <a
                            href="https://appwedoo.com"
                            className="blue-button"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://appwedoo.com
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ProductWedoo;
